import {atom} from "jotai";

const userAtom = atom({
    id: null,
    name: null,
    lastName: null,
    email: null,
    display_image: null,
    role: null,
    branch_id: null,
    branch_name: null,
    created_at: null,
    last_password_change: null,
});

export default userAtom;